import type { NavBarAlign } from '@tarslib/types/lib/publishedProject';
import type { NavbarFolderItem, NavbarItem } from '../navbar/NavbarItem';
import type { NavRightLinkItem } from './NavRightLinkItem';

export enum NavigationTypeEnum {
  None = 'NONE',
  // TopSearch = 'TOP_SEARCH',
  // FirstLevelSearch = 'FIRST_LEVEL_SEARCH',
  FirstLevelNavigation = 'FIRST_LEVEL_NAVIGATION',
  SecondLevelNavigation = 'SECOND_LEVEL_NAVIGATION',
  ThirdLevelNavigation = 'THIRD_LEVEL_NAVIGATION',
}

export type NavigationNone = {
  type: NavigationTypeEnum.None;
};

export type NavigationFirstLevelNavigation = {
  type: NavigationTypeEnum.FirstLevelNavigation;
  firstLevelNavbarItems: NavbarItem[];
  navId: string | undefined;
  align: NavBarAlign;
  navRightLinkItems: NavRightLinkItem[];
};

export type NavigationSecondLevelNavigation = {
  type: NavigationTypeEnum.SecondLevelNavigation;
  firstLevelNavbarItems: NavbarItem[];
  secondLevelNavbarItems: NavbarFolderItem[];
  navId: string;
  align: NavBarAlign;
  navRightLinkItems: NavRightLinkItem[];
};

export type NavigationThirdLevelNavigation = {
  type: NavigationTypeEnum.ThirdLevelNavigation;
  firstLevelNavbarItems: NavbarItem[];
  secondLevelNavbarItems: NavbarFolderItem[];
  thirdLevelNavbarItems: NavbarFolderItem[];
  navId: string;
  align: NavBarAlign;
  navRightLinkItems: NavRightLinkItem[];
};

export type Navigation =
  | NavigationNone
  | NavigationFirstLevelNavigation
  | NavigationSecondLevelNavigation
  | NavigationThirdLevelNavigation;
